import React from 'react';

/**
 * Custom-engineered Heritage Brand Mark for Harbor & Hide
 * Features a stylized anchor integrated with a leather hide silhouette
 */
export default function BrandMark({ className = "w-10 h-10", color = "currentColor" }) {
  return (
    <svg 
      viewBox="0 0 100 100" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg" 
      className={className}
    >
      {/* Outer Hide Shape */}
      <path 
        d="M50 5C25 5 15 15 10 40C5 65 15 85 50 95C85 85 95 65 90 40C85 15 75 5 50 5Z" 
        stroke={color} 
        strokeWidth="4" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
      {/* Integrated Anchor */}
      <path 
        d="M50 25V65M50 25L42 33M50 25L58 33" 
        stroke={color} 
        strokeWidth="4" 
        strokeLinecap="round" 
      />
      <path 
        d="M30 55C30 65 40 75 50 75C60 75 70 65 70 55" 
        stroke={color} 
        strokeWidth="4" 
        strokeLinecap="round" 
      />
      <circle cx="50" cy="20" r="4" fill={color} />
      {/* Decorative Rivets */}
      <circle cx="25" cy="40" r="2" fill={color} opacity="0.5" />
      <circle cx="75" cy="40" r="2" fill={color} opacity="0.5" />
    </svg>
  );
}